import { api } from './index';

export const costEstimationService = {
  estimateServiceProvidersAnalysis: async (providerIds: string[]) => {
    const response = await api.post('/cost-estimation/service-providers', { ids: providerIds });
    return response.data;
  },
  estimateContractsAnalysis: async (providerId: string, contractIds: string[]) => {
    const response = await api.post(`/cost-estimation/service-providers/${providerId}/contracts`, { ids: contractIds });
    return response.data;
  },
  estimateSingleContractAnalysis: async (providerId: string, contractId: string) => {
    const response = await api.get(`/cost-estimation/service-providers/${providerId}/contracts/${contractId}`);
    return response.data;
  }
};



